import React from 'react'

import { Text, Select } from 'components/base'
import SelectRoleLayout from 'components/Utils/SelectRole/Layout'
import { IncentiveBoxLayout } from 'components/Utils/IncentiveBox/Layout'

const PUBLIC_SHARING_ROLES = {
  member: {
    title: 'Members',
    description: 'All channel members including read-only',
  },
  channelWriter: {
    title: 'Channel writers',
    description: 'Channel members with writing role',
  },
  channelAdmin: {
    title: 'Channel admins',
    description: 'Channel members with admin role',
  },
  teamAdminOrOwner: {
    title: 'All admins',
    description: 'Only members with team admin or owner role',
  },
}

const INVITATION_SETTINGS_VALUE = [
  {
    title: 'Any member',
    value: true, // membersCanInvite being a boolean, we also use booleans here
    description: 'All team members',
  },
  {
    title: 'Only team admins',
    value: false,
    description: 'Only members with team admin or owner role',
  },
]

type SharingLayoutProps = {
  organizationIsFree: boolean
  organizationMembersCanInvite: boolean
  organizationRequiredRoleForPublicSharing: string
  updateOrganization: (params: any) => void
  goToOrganizationUpgrade: ({ incentiveId }: { incentiveId: string }) => void
}

export default function SharingLayout({
  organizationIsFree,
  organizationMembersCanInvite,
  organizationRequiredRoleForPublicSharing,
  updateOrganization,
  goToOrganizationUpgrade,
}: SharingLayoutProps) {
  const selectedOption = INVITATION_SETTINGS_VALUE.find(
    option => option.value === organizationMembersCanInvite
  )
  const selectedOptionValue = selectedOption ? selectedOption.value : true

  return (
    <div className="flexbox flexbox-space-between flexbox-column margin-top-large">
      <div className="width-full flexbox-align-center">
        <Text.Section className="margin-bottom-normal">
          Invitation settings
        </Text.Section>
        <div className="flexbox flexbox-align-center">
          <Select
            className="margin-right-normal"
            disabled={organizationIsFree}
            onChange={(value: boolean) => {
              updateOrganization({ membersCanInvite: value })
            }}
            options={INVITATION_SETTINGS_VALUE}
            value={selectedOptionValue}
          />
          <Text.Corpus>can invite.</Text.Corpus>
        </div>
        <div className="flexbox flexbox-align-center flexbox-no-grow margin-bottom-normal" />
      </div>
      <div className="flexbox flexbox-space-between flexbox-column margin-top-large">
        <div className="width-full flexbox-align-center margin-bottom-normal">
          <Text.Section className="margin-bottom-normal">
            Sharing permissions
          </Text.Section>
        </div>
        <div className="flexbox flexbox-align-center">
          <Text.Corpus>All</Text.Corpus>
          <div className="margin-horizontal-normal">
            <SelectRoleLayout
              disabled={organizationIsFree}
              organizationIsFree={organizationIsFree}
              goToOrganizationUpgrade={goToOrganizationUpgrade}
              roles={PUBLIC_SHARING_ROLES}
              currentRole={organizationRequiredRoleForPublicSharing}
              onSelectRole={(role: string) => {
                updateOrganization({ requiredRoleForPublicSharing: role })
              }}
            />
          </div>
          <Text.Corpus>can enable channel or doc public sharing.</Text.Corpus>
        </div>
        <IncentiveBoxLayout
          incentiveId="TeamSettings"
          className="margin-top-medium"
          isOrganizationFree={organizationIsFree}
          goToOrganizationUpgrade={goToOrganizationUpgrade}
        />
      </div>
    </div>
  )
}
